module.exports = __webpack_public_path__ + "img/close.b0200bf7.svg";